import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "@cloudscape-design/components/modal";
import Button from "@cloudscape-design/components/button";
import {
    Flex,
    Text,
    useToast
} from '@chakra-ui/react';
import c from "../../constant"
import Cards from "@cloudscape-design/components/cards";
import useStore from '../../store';
import { Avatar } from '@chakra-ui/react'
import Popover from "@cloudscape-design/components/popover";
import SelectUserModal from '../Modal/SelectUserModal';
import "./style.css"
import { gql, useLazyQuery, useMutation } from '@apollo/client';

const ADD_TO = gql`
	mutation add($id: String!, $type: String!) {
		addToAutoAssignProposal(id: $id, type: $type)
	}
`;

const REMOVE_FROM = gql`
	mutation remove($id: String!, $type: String!) {
		removeFromAutoAssignProposal(id: $id, type: $type)
	}
`;

const ASSIGN_DEPARTMENT = gql`
	mutation assign($id: String!, $department: String!) {
		assignCompanySubmissionProposalToDepartment(id: $id, department: $department)
	}
`;

const QUERY_USERS = gql`
	query get($type: String!){
		getAutoAssignProposalList(type:$type) {
			user {
				id
				username
				fullName
				fullNameKhmer
				createdAt
				role
				avatar
				active
                department
			}
            type
			id
		}
	}
`;

export default function SelectDepartmentModal({ onClose, selectedItems: fromParent, callBack, id }) {
    const { t } = useTranslation();
    const toast = useToast();
    const { currentLang } = useStore((state) => state.currentLang);
    const [departmentData, setDepartmentData] = useState()
    const [selectUserModalOpen, setSelectUserModalOpen] = useState(false)
    // gql
    const [addUser, { error: errorAdd, data: addData, loading: addLoading }] = useMutation(ADD_TO);
    const [removeUser, { error: errorRemove, data: removeData, loading: removeLoading }] = useMutation(REMOVE_FROM);
    const [loadUser, { error: errorDefault, loading: loadingDefault, data: dataDefault }] = useLazyQuery(QUERY_USERS);
    const [assignDepartment, { error: errorAssign, data: dataAssign, loading: loadingAssign }] = useMutation(ASSIGN_DEPARTMENT);

    useEffect(() => {
        loadUser({
            variables: {
                type: "department"
            }
        })
    }, [])

    useEffect(() => {
        if (addData || removeData) {
            loadUser({
                variables: {
                    type: "department"
                }
            })
        }
    }, [addData, removeData])

    useEffect(() => {
        const tmp = []
        c.departments.map((item) => {
            const tmpPeople = []
            dataDefault?.getAutoAssignProposalList?.map((u) => {
                if (u?.user?.department?.includes(item?.value)) {
                    tmpPeople.push(u)
                }
            })
            tmp.push({
                ...item,
                peoples: tmpPeople
            })
        })
        setDepartmentData(tmp)
    }, [dataDefault])

    function selectOneItem(item) {
        assignDepartment({
            variables: {
                id,
                department: item?.value ? item?.value : ""
            }
        })
    }

    useEffect(() => {
        if (dataAssign) {
            toast({
                title: t('Department updated successfully'),
                status: 'success',
                isClosable: true,
                position: 'top-right',
            });
            callBack()
            onClose()
        }
    }, [dataAssign])

    useEffect(() => {
        if (errorAssign) {
            toast({
                title: t('Department updated error'),
                status: 'error',
                isClosable: true,
                position: 'top-right',
            });
        }
    }, [errorAssign])

    function getDisplayName(user) {
        let result = user?.username;
        if (currentLang === 'kh') {
            if ((result = user?.fullNameKhmer)) {
                result = user?.fullNameKhmer;
            } else {
                if (user?.fullName) {
                    result = user?.fullName;
                } else {
                    result = user.username;
                }
            }
        } else {
            if ((result = user?.fullName)) {
                result = user?.fullName;
            } else {
                if (user?.fullNameKhmer) {
                    result = user?.fullNameKhmer;
                } else {
                    result = user.username;
                }
            }
        }
        return result;
    }
    return (
        <>
            <Modal
                onDismiss={() => {
                    onClose()
                }}
                visible={true}
                header={t("Please select departments")}
            >

                <Cards
                    className="item-card"
                    cardDefinition={{
                        header: item => (
                            <Text
                                onClick={() => {
                                    if(item?.peoples?.length>0){
                                        selectOneItem(item)
                                    } else {
                                        alert('Please add default user')
                                    }
                                }}
                                lineHeight="30px"
                                cursor={item?.peoples?.length>0?"pointer":"not-allowed"}
                                fontSize="md" 
                                textDecoration="underline"
                                color={item?.peoples?.length>0?"#0872D3":"gray.200"}
                            >
                                {currentLang === "en" ? item?.label : item?.labelKh}
                            </Text>
                        ),
                        sections: [
                            {
                                id: "departmentDirector",
                                header: "",
                                content: item => <Flex alignItems="center">
                                    {item?.peoples?.map((p) =>
                                        <Popover
                                            dismissButton={false}
                                            position="bottom"
                                            size="small"
                                            triggerType="custom"
                                            content={<>
                                                {getDisplayName(p?.user)}
                                                <Button
                                                    iconName="remove"
                                                    variant="icon"
                                                    onClick={() => {
                                                        removeUser({
                                                            variables: {
                                                                id: p?.user?.id,
                                                                type: "department"
                                                            }
                                                        })
                                                    }}
                                                />
                                            </>}
                                        >
                                            <Avatar cursor="pointer" size="xs" mr="2" name={getDisplayName(p?.user)} src={c.baseFilePath + p?.user?.avatar?.icon} />
                                        </Popover>
                                    )}
                                    <Button
                                        size="xs"
                                        onClick={() => {
                                            setSelectUserModalOpen(true)
                                        }}
                                        iconName="add-plus"
                                        variant="icon"
                                    />
                                </Flex>
                            }
                        ]
                    }}
                    cardsPerRow={[
                        { cards: 1 },
                        { minWidth: 500, cards: 2 }
                    ]}
                    items={departmentData}
                    loadingText={t("Loading")}
                    loading={false}
                    trackBy="value"
                />
            </Modal>

            {selectUserModalOpen && (
                <SelectUserModal
                    role="companySubmissionProposal"
                    callback={e => addUser({
                        variables: { id: e?.id, type: "department" }
                    })}
                    isOpen={selectUserModalOpen}
                    onClose={() => setSelectUserModalOpen(false)}
                />
            )}
        </>
    );
}
